export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ApiError";
  }
}

export class UnauthorizedError extends ApiError {
  constructor() {
    super("Unauthorized. Please ensure you have added your credentials.");
  }
}

export class IncorrectScopeError extends ApiError {
  constructor() {
    super(
      "The authentication token used does not have the correct scope. \n\nPlease create a new authentication token with the relevant scopes and then update your credentials.",
    );
  }
}

export class NotFoundError extends ApiError {
  constructor() {
    super(
      "The requested resource was not found. It may have been deleted or you may not have access to it.",
    );
  }
}

export class InvalidCredentialsError extends ApiError {
  constructor() {
    super(
      "Your credentials could not be verified. The token may be invalid or expired.",
    );
  }
}

export class UnknownError extends ApiError {
  constructor() {
    super("An unknown error occurred while calling the zeroheight API");
  }
}

export class MaxRetriesError extends ApiError {
  constructor() {
    super("Max retries exceeded while calling the zeroheight API");
  }
}

export function isExpectedAuthError(error: unknown): boolean {
  return (
    error instanceof InvalidCredentialsError ||
    error instanceof UnauthorizedError ||
    error instanceof IncorrectScopeError
  );
}
